<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('log_templates.create')" @invoke-method="invokeMethod($event)" action="openLogTemplateForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="refresh(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="log_templates" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openLogTemplateForm(props.item)">
                                <td>{{ props.item.template_name }}</td>
                                <td class="text-center">{{ props.item.version }}</td>
                                <td class="text-center">
                                    <v-chip :color="props.item.active == '1' ? 'success' : 'error'" text-color="white">
                                        {{ props.item.active == "1" ? $t("lang.active") : $t("lang.inactive") }}
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="log_templates"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="log_template_dialog">
                <v-card>
                    <v-form ref="form_log_template">
                        <v-card-title>
                            <span class="headline">{{ log_template.template_id ? $t("lang.edit_log_template") : $t("lang.add_log_template") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeLogTemplateDialog"
                                :dialog-status="log_template_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="log_template_dialog"
                                            v-model="log_template.template_name"
                                            :label="`${$t('lang.template_name')} *`"
                                            :counter="showCounter(log_template.template_name, 'log_templates.template_name')"
                                            :rules="ifValid('log_templates.template_name')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="log_template.template_id" color="error" @mouseup.left="$refs.delete_log_templates.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeLogTemplateDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveLogTemplates">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_log_templates"
                :heading="$t('lang.delete_log_template')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteLogTemplates(log_template.template_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openLogTemplateForm" },
                { title: this.$t("lang.refresh"), action: "dbGetLogTemplates", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.template_name"), sortable: false, width: "16%" },
                { text: this.$t("lang.log_version"), sortable: false, width: "16%", align: "center" },
                { text: this.$t("lang.active"), sortable: false, width: "16%", align: "center" },
            ],
            enableAddModal: true,
            enableEditModal: false,

            log_template: {},
            filter: {
                search: "",
                status: "1",
            },
            log_template_dialog: false,
            dbGetLogTemplates: _.debounce(this.getLogTemplates, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchLogTemplates", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.log_templates) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchLogTemplates({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.log_templates) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.log_templates.log_templates_filter,
            page: (state) => state.log_templates.page,
            rules_log_templates: (state) => state.log_templates.rules_log_templates,
            log_template_status_options: (state) => state.settings.log_template_status_options,
            log_templates: (state) => state.log_templates.log_templates,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchLogTemplates", "saveLogTemplate", "deleteLogTemplate"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openLogTemplateForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_log_template) item ? this.$refs.form_log_template.resetValidation() : this.$refs.form_log_template.reset();

                    this.$nextTick(() => {
                        this.log_template = item != null ? this.assignObj2(item, this.rules_log_templates) : {};
                        this.log_template_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "log_template", params: { id: item.template_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_log_template) item ? this.$refs.form_log_template.resetValidation() : this.$refs.form_log_template.reset();
                    this.log_template_dialog = true;
                } else {
                    this.$router.push({ name: "log_template" });
                }
            }
        },
        saveLogTemplates() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_log_template")) {
                    let body = this.prepForm(this.log_template, this.rules_log_templates);

                    this.saveLogTemplate({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getLogTemplates();
                                this.closeLogTemplateDialog();
                                this.refresh(true);
                            } else {
                                this.closeLogTemplateDialog();
                                this.refresh(true);
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteLogTemplates(id = null) {
            this.deleteLogTemplate({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getLogTemplates();
                    this.closeLogTemplateDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeLogTemplateDialog() {
            this.log_template_dialog = false;
            this.$refs.delete_log_templates.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getLogTemplates(pg_refresh = false) {
            this.startLoader();

            this.fetchLogTemplates({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.log_template_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        refresh(force = false) {
            this.fetchLogTemplates({ body: {} }).then((data) => {
                if (typeof data !== "undefined" && data.log_templates) {
                    this.finishLoader(force);
                } else {
                    this.$router.push({ name: "dashboard", replace: true });
                }
            });
        },
    },
};
</script>
